// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aD32W8 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  min-width: 0;
}

.pWSCoQ {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: -4px 0 -8px;
  padding: 4px 0 8px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
}

.pWSCoQ::-webkit-scrollbar {
  display: none;
}

._9JN5Ko {
  cursor: grab;
  touch-action: pan-x;
}

.Ol4yIG {
  cursor: grabbing;
  scroll-snap-type: none;
  scroll-behavior: auto;
  user-select: none;
}

.c_8dKS {
  display: flex;
  width: 100%;
  gap: var(--spacing-3);
}

.NJEcy8 {
  box-sizing: border-box;
  display: flex;
  flex: 0 0 100%;
  align-items: center;
  gap: var(--spacing-2);
  min-width: 0;
  height: 74px;
  padding: var(--spacing-2) var(--spacing-3);
  border-radius: var(--radius-s);
  background-color: var(--surface-neutral-white);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  scroll-snap-align: start;
}

.CdAMm9 .NJEcy8 {
  flex: 0 0 calc((100% - var(--spacing-3)) * 733 / 1088);
}

.J0wBuC {
  display: flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-primary-medium);
}

.qfpDac {
  width: 16px;
  height: 16px;
}

.n9YtKp {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  white-space: nowrap;
}

.s_GlHk {
  display: inline-block;
  max-width: 40%;
  overflow: hidden;
  font: inherit;
  text-overflow: ellipsis;
  vertical-align: bottom;
  white-space: nowrap;
}

.ecJGoa {
  flex: 0 0 auto;
  min-height: 32px;
}

.d17epo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-0-5);
}

.xvcLnf {
  width: 5px;
  height: 5px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-pill);
  background-color: var(--icon-neutral-medium);
  cursor: pointer;
}

.d7aihh {
  background-color: var(--surface-primary-medium);
}

.xvcLnf:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
}

@media (max-width: 1023px) {
  .CdAMm9 .NJEcy8 {
    flex: 0 0 100%;
  }
}

@media (max-width: 768px) {
  .NJEcy8 {
    height: auto;
    min-height: 74px;
    padding: var(--spacing-2);
  }

  .n9YtKp {
    white-space: normal;
  }

  .s_GlHk {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/PendingPaymentNotices/PendingPaymentNotices.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,8BAA8B;EAC9B,8CAA8C;EAC9C,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,iCAAiC;EACjC,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n  min-width: 0;\n}\n\n.viewport {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: -4px 0 -8px;\n  padding: 4px 0 8px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: none;\n}\n\n.viewport::-webkit-scrollbar {\n  display: none;\n}\n\n.viewportDraggable {\n  cursor: grab;\n  touch-action: pan-x;\n}\n\n.viewportDragging {\n  cursor: grabbing;\n  scroll-snap-type: none;\n  scroll-behavior: auto;\n  user-select: none;\n}\n\n.track {\n  display: flex;\n  width: 100%;\n  gap: var(--spacing-3);\n}\n\n.notice {\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 0 100%;\n  align-items: center;\n  gap: var(--spacing-2);\n  min-width: 0;\n  height: 74px;\n  padding: var(--spacing-2) var(--spacing-3);\n  border-radius: var(--radius-s);\n  background-color: var(--surface-neutral-white);\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  scroll-snap-align: start;\n}\n\n.trackCarousel .notice {\n  flex: 0 0 calc((100% - var(--spacing-3)) * 733 / 1088);\n}\n\n.iconContainer {\n  display: flex;\n  flex: 0 0 32px;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-primary-medium);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.message {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  white-space: nowrap;\n}\n\n.reference {\n  display: inline-block;\n  max-width: 40%;\n  overflow: hidden;\n  font: inherit;\n  text-overflow: ellipsis;\n  vertical-align: bottom;\n  white-space: nowrap;\n}\n\n.payButton {\n  flex: 0 0 auto;\n  min-height: 32px;\n}\n\n.dots {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-0-5);\n}\n\n.dot {\n  width: 5px;\n  height: 5px;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-pill);\n  background-color: var(--icon-neutral-medium);\n  cursor: pointer;\n}\n\n.dotActive {\n  background-color: var(--surface-primary-medium);\n}\n\n.dot:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n}\n\n@media (max-width: 1023px) {\n  .trackCarousel .notice {\n    flex: 0 0 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .notice {\n    height: auto;\n    min-height: 74px;\n    padding: var(--spacing-2);\n  }\n\n  .message {\n    white-space: normal;\n  }\n\n  .reference {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `aD32W8`,
	"viewport": `pWSCoQ`,
	"viewportDraggable": `_9JN5Ko`,
	"viewportDragging": `Ol4yIG`,
	"track": `c_8dKS`,
	"notice": `NJEcy8`,
	"trackCarousel": `CdAMm9`,
	"iconContainer": `J0wBuC`,
	"icon": `qfpDac`,
	"message": `n9YtKp`,
	"reference": `s_GlHk`,
	"payButton": `ecJGoa`,
	"dots": `d17epo`,
	"dot": `xvcLnf`,
	"dotActive": `d7aihh`
};
module.exports = ___CSS_LOADER_EXPORT___;
